import axiosInstance from './axiosInstance'

export interface AuditUser {
  id: string
  name: string
  email: string
  avatarUrl: string | null
}

export interface Attachment {
  id: string
  recordId: string
  fileName: string
  url: string
  contentType: string
  sizeBytes: number
  uploadedBy: AuditUser | null
  createdAt: string
}

export type ModuleType = 'lead' | 'contact' | 'customer' | 'deal' | 'sales'

const getUrl = (moduleType: ModuleType, recordId: string) => {
  if (moduleType === 'sales') return `/sales/${recordId}/attachments`
  return `/${moduleType}s/${recordId}/attachments`
}

export const attachmentsApi = {
  /**
   * Get all attachments for a record
   */
  getAll: (moduleType: ModuleType, recordId: string) =>
    axiosInstance
      .get<{ data: Attachment[] }>(getUrl(moduleType, recordId))
      .then(r => r.data.data),

  /**
   * Upload a file to a record
   */
  upload: (moduleType: ModuleType, recordId: string, file: File, onProgress?: (pct: number) => void) => {
    const form = new FormData()
    form.append('file', file)
    return axiosInstance
      .post<{ data: Attachment }>(getUrl(moduleType, recordId), form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: e => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total))
        },
      })
      .then(r => r.data.data)
  },

  /**
   * Delete an attachment
   */
  delete: (moduleType: ModuleType, recordId: string, attachmentId: string) =>
    axiosInstance.delete(`${getUrl(moduleType, recordId)}/${attachmentId}`),
}
